const pageBackgroundImgLayoutOptions = [
  {
    label: '顶部',
    value: 'top'
  },
  {
    label: '底部',
    value: 'bottom'
  }
]

export const config = {
  propsName: 'renderProps',
  name: 'formPageConfig',
  type: 'homeConfig',
  icon: 'el-icon-setting',
  cnName: '表单页面配置',
  tooltip: '表单页面配置',
  base: {
    
  },
  props: [    
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '页面名称',
        placeholder: '请输入页面名称'
      },
      value: '页面名称'
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {
        label: '背景色',
      },
      on: {},
      value: ''
    },
    {
      // tooltip:'背景图的tooltip',
      type: 'sp-backgroundImg',
      key: 'backgroundImg',
      bind: {
        label: '背景图',
        'layout-type':2,
        'layout-options':pageBackgroundImgLayoutOptions,
        quoteKey:'backgroundImg'
      },
      on: {},
      value: {}
    },    
  ]
}
